import React from "react"
import PropTypes from "prop-types"
import { Button, Flex } from "antd"
import { useTranslation } from "react-i18next"
import { Icon } from "ui/Icon"
import styles from "./UnavailableExperience.module.css"

// Shown in place of an experience (its page, or the booking in the cart / checkout) when it can't
// be loaded: removed, unpublished, or a bad link. Leads back to the list of experiences.
const UnavailableExperience = ({ onChooseExperience }) => {
  const { t } = useTranslation()
  return (
    <Flex vertical align="center" justify="center" gap={24} className={styles.box} role="alert">
      <span className={styles.icon}>
        <Icon type="feather" name="AlertCircle" width={40} height={40} color="currentColor" />
      </span>
      <Flex vertical align="center" gap={4}>
        <span className={styles.title}>{t("booking_widget.unavailable.title")}</span>
        <span className={styles.text}>{t("booking_widget.unavailable.text")}</span>
      </Flex>
      <Button type="primary" shape="round" size="large" onClick={onChooseExperience}>
        {t("booking_widget.cart.choose_experience")}
      </Button>
    </Flex>
  )
}

UnavailableExperience.propTypes = {
  onChooseExperience: PropTypes.func.isRequired
}

export default UnavailableExperience
